import { observer } from "mobx-react-lite";
import useTranslation from "../../hooks/useTranslation";
import caseStore from "../../stores/CaseStore";
import CaseItem from "../../components/Cases/CaseItem";
import { useEffect, useState } from "react";
import { Case, CaseStatus } from "../../stores/CaseStore/types";
import "./UserCases.scss";
import offerStore from "../../stores/OfferStore";

const UserCases = observer(
  ({
    summaryMode = false,
    fetchCases = false,
    fetchOffers = false,
  }: {
    summaryMode?: boolean;
    fetchCases?: boolean;
    fetchOffers?: boolean;
  }) => {
    const { t } = useTranslation();
    const [cases, setCases] = useState<{
      activeCases: Case[];
      pendingCases: Case[];
      inactiveCases: Case[];
      rejectedCases: Case[];
      onHoldCases: Case[];
    }>({
      activeCases: [],
      pendingCases: [],
      inactiveCases: [],
      rejectedCases: [],
      onHoldCases: [],
    });

    useEffect(() => {
      if (fetchCases) {
        caseStore.fetchUserCases().then();
      }

      if (fetchOffers) {
        offerStore.fetchUserOffers();
      }
    }, []);

    useEffect(() => {
      setCases({
        activeCases: caseStore.userCases.filter(
          (caseItem) => caseItem.status === CaseStatus.ACTIVE
        ),
        pendingCases: caseStore.userCases.filter(
          (caseItem) => caseItem.status === CaseStatus.PENDING
        ),
        inactiveCases: caseStore.userCases.filter(
          (caseItem) => caseItem.status === CaseStatus.DEACTIVE
        ),
        rejectedCases: caseStore.userCases.filter(
          (caseItem) => caseItem.status === CaseStatus.REJECTED
        ),
        onHoldCases: caseStore.userCases.filter(
          (caseItem) => caseItem.status === CaseStatus.ON_HOLD
        ),
      });
    }, [caseStore.userCases]);

    const summary = (
      <div className="summary">
        <div>
          <span className="mb">
            <i className="fal fa-clock" /> {t("open-cases")}:&nbsp;
            {cases.activeCases.length}
          </span>
          <span className="mb">
            <i className="fal fa-lock" /> {t("pending-cases")}:&nbsp;
            {cases.pendingCases.length}
          </span>
          <span className="mb">
            <i className="fal fa-vote-nay" /> {t("rejected-cases")}:&nbsp;
            {cases.rejectedCases.length}
          </span>
          <span className="mb">
            <i className="fal fa-handshake" /> {t("inactive-cases")}:&nbsp;
            {cases.inactiveCases.length}
          </span>
        </div>
      </div>
    );

    return summaryMode ? (
      summary
    ) : (
      <div className="userCasesContainer">
        <h3>
          {t("open-cases")} ({cases.activeCases.length})
        </h3>
        <div className="activeCases">
          {cases.activeCases.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>

        <h3>
          {t("pending-cases")} ({cases.pendingCases.length})
        </h3>
        <div className="pendingCases">
          {cases.pendingCases.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>

        <h3>
          {t("rejected-cases")} ({cases.rejectedCases.length})
        </h3>
        <div className="rejectedCases">
          {cases.rejectedCases.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>

        <h3>
          {t("inactive-cases")} ({cases.inactiveCases.length})
        </h3>
        <div className="inactiveCases">
          {cases.inactiveCases.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>

        <h3>
          {t("on-hold-cases")} ({cases.onHoldCases.length})
        </h3>
        <div className="onHoldCases">
          {cases.onHoldCases.map((caseItem) => (
            <CaseItem key={caseItem.id} caseItem={caseItem} />
          ))}
        </div>
      </div>
    );
  }
);

export default UserCases;
